module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"EndItems\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/end-items/end-items.component.html
// module id = ./src/app/end-items/end-items.component.html
// module chunks = main